import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { ZoneService } from 'src/app/services/zone.service';

@Component({
    selector: 'app-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss']
})

export class AddZoneComponent implements OnInit {

    addZoneForm: FormGroup;
    isFormSubmitted = false;
    cellData: any;
    useEnterKey: any;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
      };

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private fb: FormBuilder,
        private zoneService: ZoneService,
        private titleService: Title,
        private utilities: Utilities,
    ) {
        titleService.setTitle('Zones');
    }



    ngOnInit() {
        this.addZoneForm = this.fb.group({
            txtZoneCode: [null, Validators.required],
            txtZoneTitle: [null, Validators.required],
        });

        this.useEnterKey = !this.appCoreService.GetUserData().metaInfo.tabbasedtemplate;
        this.useEnterKey ? this.utilities.focusFirstElement(this.addZoneForm) : null;
        this.checkPermission();
    }

    
  checkPermission(): any {
    const userData = this.appCoreService.GetUserData(); 
    const permission = userData.config.filter(x => x.categoryname === 'Zones');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

    async onSaveClick() {
        this.isFormSubmitted = true;
        if (this.addZoneForm.valid) {
            const reqObj = {
                zonecode: this.addZoneForm.get('txtZoneCode')?.value,
                zonetitle: this.addZoneForm.get('txtZoneTitle')?.value,
            };
            this.ngxLoaderService.start();
            this.zoneService.Add(reqObj).subscribe((res) => {
                if (res) {
                    this.ngxLoaderService.stop();
                    if (res?.data?.err_msg) {
                        return this.appCoreService.showMessage(res.data.err_msg, 'Error', 'error');
                    } else {
                        this.appCoreService.showMessage('Zone added successfully.');
                        this.activeModal.close('Save Click');
                    }
                }
            });
        }
    }

}
